import React, { useCallback, useEffect, useState } from 'react'
import { Button, Form, InputGroup } from 'react-bootstrap'

interface QuantityConfigProps {
    handleQuantitySetter: (quantity: number) => void;
    currentQty: number;
    size: 'sm' | 'lg';
}

const QuantityConfig = (props: QuantityConfigProps) => {

    const { handleQuantitySetter, currentQty, size } = props;

    const [quantity, setQuantity] = useState<number>(currentQty);
    
    const handleDecreaseQuantity = useCallback(() => {
        setQuantity((prev) => {
            let i = prev - 1;
            return i < 0 ? 0 : i;
        })
    }, []);
   
    const handleIncreaseQuantity = useCallback(() => {
        setQuantity((prev) => prev + 1);
    }, []);


    useEffect(() => {
        void handleQuantitySetter(quantity);
    }, [quantity]);

    const theSize = size === 'lg' ? 'lg' : 'sm';


    return (
        <InputGroup size={theSize} style={{width: 'fit-content'}}>
            <Button
                variant="outline-default"
                onClick={handleDecreaseQuantity}
                tabIndex={-1}
                style={{ 
                    padding: "0.375rem 0.75rem", 
                    borderTopLeftRadius: '0.375rem',
                    borderBottomLeftRadius: '0.375rem',
                    borderColor: '#dee2e6',
                    
                }}
            >–</Button>
            <Form.Control
                type="text"
                name='quantity'
                value={quantity}
                onChange={(e) => setQuantity(e.target.value ? Number(e.target.value) : 1)}
                style={{ width: "46px", paddingRight: '3px', flex: '0 1 auto' }}
            />
            <Button
                variant="outline-default"
                onClick={handleIncreaseQuantity}
                tabIndex={-1}
                style={{ 
                    padding: "0.375rem 0.75rem", 
                    borderTopRightRadius: '0.375rem',
                    borderBottomRightRadius: '0.375rem',
                    borderColor: '#dee2e6',
                    
                }}
            >+</Button>
        </InputGroup>
    )
}

export default QuantityConfig
